import { render, staticRenderFns } from "./cube-button-group.vue?vue&type=template&id=0f23606e&"
import script from "./cube-button-group.vue?vue&type=script&lang=js&"
export * from "./cube-button-group.vue?vue&type=script&lang=js&"
import style0 from "./cube-button-group.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports